import React from 'react'

export default class Display extends React.Component {
  constructor(props) {
    super(props)
    this.canvasRef = React.createRef()
    this.trigger = 128
    this.height = this.props.height || 160
    this.width = this.props.width || 1200
  }

  componentDidMount() {
    this.context = this.canvasRef.current.getContext('2d')
  }

  draw(audioData) {
    this.context = this.canvasRef.current.getContext('2d')
    this.context.beginPath()
    this.context.moveTo(0, this.height / 2)

    const troughs = []
    const frames = []
    for (const frame of audioData) {
      this._processFrame(frame, troughs)
      if (troughs.length > 1) {
        frames.push(frame)
      }
    }

    const sliceWidth = (this.width * 1.3) / audioData.length
    let sliceStart = 0
    for (const frame of frames) {
      const percentHeight = frame / this.trigger
      const y = (percentHeight * this.height) / 3 + this.height / 6
      this.context.lineTo(sliceStart, y)
      sliceStart += sliceWidth
    }
    this.context.fillStyle = 'rgb(0,0,0)'
    this.context.fillRect(0, 0, this.width, this.height)
    this.context.lineWidth = 1
    this.context.strokeStyle = 'rgb(50, 225, 50)'
    this.context.stroke()
  }

  _processFrame = (frame, troughs) => {
    if (this.prevFrame < this.trigger && frame >= this.trigger) {
      troughs.push(frame)
    }
    this.prevFrame = frame
  }

  render() {
    return <canvas ref={this.canvasRef} id="display" width={this.width} height={this.height} />
  }
}
